<template>
  <div class="answer-operate">
    <ul :style="operateStyle">
      <li v-if="viewableAfterSubmit" @click="onPreview">
        <div>
          <img src="~@/assets/img/svg/show-content.svg" alt="" />
        </div>
        <div>
          <span>查看已填内容</span>
        </div>
      </li>
      <li v-if="canAnswerAgain && enableAgainBtn" @click="onAgain">
        <div>
          <img src="~@/assets/img/svg/again.svg" alt="" />
        </div>
        <div>
          <span>再填一份</span>
        </div>
      </li>
      <li v-if="enableShareBtn" @click="onShare">
        <div>
          <img src="~@/assets/img/svg/share.svg" alt="" />
        </div>
        <div>
          <span>立即分享</span>
        </div>
      </li>
      <li v-if="hasHistory && enableHistoryBtn" @click="onShowHistory">
        <div>
          <img src="~@/assets/img/svg/history.svg" alt="" />
        </div>
        <div>
          <span>历史答题记录</span>
        </div>
      </li>
      <li v-if="enableUserExportAnswer" id="copyDownloadLink" @click="onCopyDownloadLink">
        <div>
          <img src="~@/assets/img/svg/history.svg" alt="" />
        </div>
        <div class="text-red">
          <span>复制PDF文件链接</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Message } from 'dygc-ui'
import { busGetters, copyText } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import SharePopup from '@/components/popup/SharePopup'
import HistoryPopup from '@/components/popup/HistoryPopup'
import ShareHistoryPopup from '@/components/popup/ShareHistoryPopup'

export default {
  name: 'AnswerOperate',
  computed: {
    operateStyle(){
      return this.$bus.survey.otherSetting.operateStyle || ''
    },
    enableShareBtn() {
      if ('enableShareBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableShareBtn
      return true
    },
    enableAgainBtn() {
      if ('enableAgainBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableAgainBtn
      return true
    },
    enableHistoryBtn() {
      if ('enableHistoryBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableHistoryBtn
      return true
    },
    enableUserExportAnswer() {
      return this.$bus.survey.otherSetting.enableUserExportAnswer && this.answerId
    },
    viewableAfterSubmit() {
      return this.$bus.viewableAfterSubmit && this.$bus.answerId
    },
    ...busGetters(['canAnswerAgain', 'hasHistory', 'answerId'])
  },
  methods: {
    onCopyDownloadLink() {
      const text = `${window.location.origin}/answer/export/userGetAnswerPdfById?answerId=${this.answerId}&isShowSystem=false`
      copyText('#copyDownloadLink', text).then(() => {
        Message.success('复制成功')
      })
    },
    onPreview() {
      if (this.$bus.params.isTest) {
        Message({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      this.$router.push({
        name: 'preview',
        params: {
          id: this.$bus.answerId
        }
      })
    },
    onShare() {
      if (this.$bus.params.isTest) {
        Message({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      createPopup(ShareHistoryPopup, {
        accountUserId: this.$bus.params.accountUserId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        surveyId: this.$bus.survey.id,
        answerId: this.$bus.answerId,
        url: this.$bus.getUrl(1)
      })
      return
      if (this.$bus.share) {
        const url = this.$bus.getUrl(1)
        createPopup(SharePopup, {
          isTest: this.$bus.params.isTest,
          url
        })
      } else {
        window.navigator.clipboard.writeText(window.location.href)
        Message({
          message: '复制成功',
          type: 'success'
        })
      }
    },
    onAgain() {
      if (!this.canAnswerAgain) return
      this.$bus.openLoading()
      this.$bus
        .refreshSurvey()
        .then(() => {
          this.$bus.closeLoading()
          this.againHandler()
        })
        .catch(() => {
          this.$bus.closeLoading()
          this.againHandler()
        })
    },
    againHandler() {
      this.$bus.isOpenReward = false
      this.$bus.scoreEnd = null
      this.$bus.answerId = null
      this.$bus.onStart(true)
    },
    onShowHistory() {
      if (this.$bus.params.isTest) {
        Message({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      createPopup(HistoryPopup, {
        accountUserId: this.$bus.params.accountUserId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        surveyId: this.$bus.survey.id
      })
    }
  }
}
</script>
